<template>
<div class="card">
    <div class="card-header">Offer</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="12"/>

            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="12" :requestId="request.id"
                        and v-if="!isUnderReview"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="2">
                <BaseTextOutput label="Request Submitter"
                                :value="request.submitter.name"/>
                </b-col>
                <b-col cols="2">
                <BaseTextOutput label="Staffing Specialist"
                                :value="request.assigned.name"/>
                </b-col>
              <b-col cols="2">
                <BaseTextOutput label="Hiring Supervisor"
                                :value="request.supervisor.name"/>
              </b-col>
            </b-row>

            <b-row v-if="isSpecialist">
              <b-col>
                <BaseSwitchInput v-model="bypass"
                                 :v="$v.bypass"
                                 label="Bypass Send Offer Letter to Requester?"
                                 tip=""
                                 :v-if="this.request?.requestTypeValue?.code !== '10'"
                />
              </b-col>
            </b-row>

            <b-row v-show="request.offerMethod">
              <b-col cols="2">
                <BaseTextOutput label="Offer Method"
                                :value="request.offerMethod"/>
                </b-col>
                <b-col cols="2">
                <BaseTextOutput label="Contingent Offer Made"
                                :value="request.contingentOfferMadeDate"/>
                </b-col>
              <b-col cols="2">
                <BaseTextOutput label="Offer Outcome"
                                :value="request.offerOutcome"/>
              </b-col>
              <b-col cols="2">
                <BaseTextOutput label="Offer Decline Reason"
                                :value="request.offerDeclineReason"/>
              </b-col>
              <b-col cols="2">
                <BaseTextOutput label="Offer Next Steps"
                                :value="request.offerNextStep"/>
              </b-col>
              <b-col cols="6" v-show="request.offerOtherText">
                <BaseTextOutput label="Offer Other Comments"
                                :value="request.offerOtherText"/>
              </b-col>

            </b-row>
            <hr/>
            <b-form @submit.stop.prevent="onSubmit">

            <b-row v-show="isUnderReview">
                <b-col>
                    <b-table-simple id="fundingStrs" hover small caption-top responsive>
                        <b-thead>
                            <b-tr>
                                <b-th style="width: 6rem">Percent</b-th>
                                <b-th>Fund</b-th>
                                <b-th>Fin Dept ID</b-th>
                                <b-th>Approp ID</b-th>
                                <b-th>SW Cost</b-th>
                                <b-th>Sub Acct</b-th>
                                <b-th>Agcy Cost 1</b-th>
                                <b-th>Agcy Cost 2</b-th>
                                <b-th>Project</b-th>
                                <b-th>Activity</b-th>
                                <b-th style="width: 10rem">Source</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item, index) in funding" :key="index">
                                <b-td><b-form-input v-model="item.fundingPercent" aria-label="Percent"
                                    :class="{'is-invalid':$v.funding.$each[index].fundingPercent.$invalid, 
                                        'is-valid':!$v.funding.$each[index].fundingPercent.$invalid}" /></b-td>
                                <b-td><b-form-input v-model="item.fundId" aria-label="Fund"
                                    :class="{'is-invalid':$v.funding.$each[index].fundId.$invalid, 
                                        'is-valid':!$v.funding.$each[index].fundId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.divisionId" aria-label="Fin Dept ID"
                                    :class="{'is-invalid':$v.funding.$each[index].divisionId.$invalid, 
                                        'is-valid':!$v.funding.$each[index].divisionId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.appropriationId" aria-label="Approp ID"
                                    :class="{'is-invalid':$v.funding.$each[index].appropriationId.$invalid, 
                                        'is-valid':!$v.funding.$each[index].appropriationId.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.swCost" aria-label="SW Cost"/></b-td>
                                <b-td><b-form-input v-model="item.subAccount" aria-label="Sub Account"/></b-td>
                                <b-td><b-form-input v-model="item.agcyCost1" aria-label="Agcy Cost 1"/></b-td>
                                <b-td><b-form-input v-model="item.agcyCost2" aria-label="Agcy Cost 2"/></b-td>
                                <b-td><b-form-input v-model="item.project" aria-label="Project" maxlength="15" @keyup="maxLengthAlert"
                                    :class="{'is-invalid':$v.funding.$each[index].project.$invalid, 
                                        'is-valid':!$v.funding.$each[index].project.$invalid}"/></b-td>
                                <b-td><b-form-input v-model="item.activity" aria-label="Activity"
                                    :class="{'is-invalid':$v.funding.$each[index].activity.$invalid, 
                                        'is-valid':!$v.funding.$each[index].activity.$invalid}" /></b-td>
                                <b-td><b-form-select v-model="item.sourceType" aria-label="Source Type"
                                    :options="sourceTypeOptions"
                                    :class="{'is-invalid':$v.funding.$each[index].sourceType.$invalid, 
                                        'is-valid':!$v.funding.$each[index].sourceType.$invalid}"/></b-td>
                                <b-td>
                                    <b-button size="sm" variant="link" @click="removeFundingStringRow(index)">
                                        <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                                    </b-button>
                                </b-td>
                            </b-tr>
                            <b-tr>
                              <b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td><b-td></b-td>
                              <b-td><span v-if="displayWarning" :class="{'text-danger': displayWarning}">Maximum of {{ projectMaxLength }} characters reached.</span></b-td>
                              <b-td></b-td><b-td></b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-button type="button" variant="outline-primary" size="sm"
                        @click="addFundingStringRow()">
                        Add additional funding string
                    </b-button>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">
                     <BaseDateInput v-model="request.contingentOfferMadeDate" 
                            :v="$v.request.contingentOfferMadeDate"
                            label="Contingent Offer Made Date"
                            slug="offer-date"
                            v-if="!isUnderReview" />
                </b-col>
            </b-row>

            <b-row v-if="bypass && isSpecialist">
              <b-col cols="12" lg="3">
                <BaseSelector v-model="request.offerMethod"
                              :v="$v.request.offerMethod"
                              label="Offer Making Method"
                              slug="offerMethod"
                              :options = offerMethodOptions />
              </b-col>
              <b-col cols="12" lg="3">
                <BaseSelector v-model="request.offerOutcome"
                              :v="$v.request.offerOutcome"
                              label="Offer Decision"
                              slug="offerOutcome"
                              :options = offerOutcomeOptions />
              </b-col>
              <b-col cols="12" lg="3">
                <BaseSelector v-model="request.offerNextStep"
                              :v="$v.request.offerNextStep"
                              label="Next Steps"
                              slug="nextSteps"
                              :options = offerNextStepsOptions />
              </b-col>
              <b-col cols="12" lg="3">
                <BaseDateInput v-model="request.effectiveStartDate"
                               :v="$v.request.effectiveStartDate"
                               label="Effective Start Date"
                               slug="start-date"/>
              </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">
                     <BaseDateInput v-model="request.offerAcceptanceDate" 
                            :v="$v.request.offerAcceptanceDate"
                            label="Offer Acceptance Date"
                            slug="acceptance-date"
                            v-if="!isUnderReview" />
                </b-col>
            </b-row>

                <b-row>
                    <b-col>
                        <BaseParagraphInput v-model="request.offerComments"
                            :v="$v.request.offerComments" 
                            slug="offerComments"
                            label="Internal Comments"/>
                    </b-col>
                </b-row>
                
                <div>
                    <b-button type="button" variant="primary" @click="onSubmitOffer"
                        :disabled="(!bypass && !offerMade) || !hasReqAttachments()"
                        >Complete Offer</b-button>   
                    <b-button type="button" variant="outline-primary" @click="sendOfferLetterToRequester"
                        :disabled="bypass || !hasReqAttachments()"
                        v-if="!isUnderReview">Send Offer Letter to Requester</b-button>                                            
                    <b-button type="button" variant="primary" @click="onSubmitReviewOffer"
                        v-if="isUnderReview">Mark Verified By Financial Management</b-button>                
                    <b-button type="button" variant="outline-primary" @click="showModal"
                        v-if="!isUnderReview">
                        Offer to a different candidate</b-button>
                    <b-button type="button" variant="outline-primary" @click="save"
                        v-if="!isUnderReview">Save</b-button>
                    <b-button type="button" variant="outline-primary" @click="onSubmitSave"
                        v-if="isUnderReview">Save</b-button>    
                    <b-button type="button" variant="outline-primary" @click="repost">Repost Position</b-button>
                </div>
            </b-form>


    </div>
  <b-modal id="modal-offer-different" hide-header hide-footer @hidden="close">
    <h2>Offer to a different candidate</h2>
    <hr/>
    <form ref="form" @submit.prevent="onReturnToPriorLifecycle()">
      <BaseParagraphInput v-model="offerDifferentCandidateComment"
                          :v="$v.offerDifferentCandidateComment"
                          slug="assignmentComments"
                          :required="$v.offerDifferentCandidateComment.$params.required ? true : false"
                          label="Reason for offering to different candidate"/>
      <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
      <b-button type="submit" variant="primary" :disabled="$v.offerDifferentCandidateComment.$invalid">Submit</b-button>
    </form>
  </b-modal>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import { commonOptions } from '@/mixins/commonOptions.js'
import _ from "lodash"
import BaseTextOutput from "@/components/BaseTextOutput";
import BaseParagraphInput from "@/components/BaseParagraphInput";
import {roleService} from "@/mixins/roleService";

const terms = ['TBD', 'tbd']
const tbdValidator = (value) => !terms.some(el => value && value.indexOf(el) > -1)

export default {
    components: {
      BaseParagraphInput,
      BaseTextOutput,
      LifecycleCheckList
    },
    mixins: [
       commonOptions,
       roleService
    ],
    props: {
        request: Object
    },
    data() {
        return {
            funding: this.request.funding,            
            comments: '',
            checklistComplete: false,
            saveOnly: false,
            totalFundingStringPercent: 'valid',
            offerDifferentCandidateComment: null,
            isOfferDifferentCandidate: false,
            offerMade: false,
            attachmentReqs: [],
            defaultFunding: {
                id: null, 
                fundingPercent: null, 
                fundId: '',
                divisionId: '',
                appropriationId: '',
                swCost: '',
                subAccount: '',
                agcyCost1: '',
                agcyCost2: '',
                project: '',
                activity: '',
                sourceType: ''                    
            },
            projectMaxLength: 15,
            displayWarning: false,
            bypass: this.request?.requestTypeValue?.code !== '10' && this.isSpecialist,
        }
    },
     validations: {
         bypass: {required},
         checklistComplete: { checked: value => value === true },
         comments: { required: false, maxLength: maxLength(4000) },
         request: {
             offerComments: { required: false, maxLength: maxLength(4000) },
             offerAcceptanceDate: { required: false },
             contingentOfferMadeDate: { required: false },
             offerMethod: { required },
             offerOutcome: { required },
             offerNextStep: { required },
             effectiveStartDate: {required: false},
        },
        totalFundingStringPercent: {
            required,
        },
        offerDifferentCandidateComment:{
          required: requiredIf(function() {
            return this.isOfferDifferentCandidate
          }) , maxLength: maxLength(4000)
        },
        funding: {
            required,
            minLength: minLength(1),
            $each: {
                fundingPercent: {
                    required,
                    numeric
                },
                fundId: {
                    required,
                    tbdValidator
                },
                divisionId: {
                    required,
                    tbdValidator
                },
                sourceType: {
                    required: requiredIf(function(item) {
                        return item.project || item.activity
                    }),
                },
                appropriationId: {
                    required,
                    tbdValidator
                },
                project: {
                    required: requiredIf(function(item) {
                        return ((item.fundId === '3000' || item.fundId === '3001') ||
                                (item.activity || item.sourceType))
                    }),
                    tbdValidator
                },
                activity: {
                    required: requiredIf(function(item) {
                        return item.project || item.sourceType
                    }),
                    maxLength: maxLength(15),
                    tbdValidator
                }
            },            
        },        
     },
    watch: {
        funding: {
            deep: true,
             handler() {
                 this.totalFundingStrings()
             }
        }
    },
    computed: {
        isUnderReview: function() {
            return (this.isFfm() &&
                this.request.financeRequiresReview === true)
        },
    },
    created() {
        if (this.request.financeRequiresReview === true) {
            this.checklistComplete = true
            this.comments = this.request.fmReviewComments
        } else {
            this.comments = this.request.offerComments
        }
        this.findOfferStatus()
        this.findReqAttachments()
    },
      
    mounted: function() {
        this.autosave()
    },
    
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },

    methods: {
        totalFundingStrings() {
            var total = _.sumBy(this.funding, item => Number(item.fundingPercent))
            this.totalFundingStringPercent = total === 100 ? "valid" : ""
        },
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },
        addFundingStringRow() {
            if (!this.funding) {
                this.funding = []
            }
            var newFunding = {... this.defaultFunding}
            this.funding.push(newFunding)
        },
        removeFundingStringRow(idx) {
            if (this.request.funding && this.request.funding.length > 1) {
                this.request.funding.splice(idx, 1)
            }
        },
        showModal(){
          this.$bvModal.show('modal-offer-different');
          this.isOfferDifferentCandidate = true;
        },
        close(){
          this.$bvModal.hide('modal-offer-different')
          this.isOfferDifferentCandidate = false;
        },

        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },
        
        save() {
            this.saveOnly = true
            this.onSubmitOffer()
            this.saveOnly = false
        },

        onSubmitSave() {
            this.totalFundingStrings()
            this.$v.funding.$touch()
            this.$v.totalFundingStringPercent.$touch()
            if (this.$v.funding.$invalid || this.$v.totalFundingStringPercent.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            let payload = {
                id: this.request.id,
                funding: this.funding,
                comments: this.request.fmReviewComments
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/fmReview/save`, payload)
                  .then(response => {            
                    this.showRootToast("Updated", "Your changes has been recorded.", "success")
                    this.$router.push('/home')
                  })
        },


        onSubmitReviewOffer() {
            this.totalFundingStrings()
            this.$v.funding.$touch()
            this.$v.totalFundingStringPercent.$touch()
            if (this.$v.funding.$invalid || this.$v.totalFundingStringPercent.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            let payload = {
                id: this.request.id,
                funding: this.funding,
                comments: this.request.fmReviewComments
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/fmReview`, payload)
                  .then(response => {            
                    this.showRootToast("Updated", "Your review has been recorded.", "success")
                    this.$router.push('/home')
                  })
        },

        onSubmitOffer() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.request.offerComments,
                contingentOfferMadeDate: this.request.contingentOfferMadeDate,
                offerAcceptanceDate: this.request.offerAcceptanceDate,
                effectiveStartDate: this.request.effectiveStartDate,
                offerNextStep: this.request.offerNextStep,
                offerOutcome: this.request.offerOutcome,
                offerMethod: this.request.offerMethod,
                advanceNextLifecycle: !this.saveOnly,
                nextLifecycle: '13',
            }
            console.log("We are submitting the offer to the next stage");
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/offer`, payload)
                  .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })                  
        },

        onReturnToPriorLifecycle() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '11',
                comment: this.offerDifferentCandidateComment
            }
            console.log("We are going back with this as the comment:",this.offerDifferentCandidateComment)
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                  .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", 
                        "Success", "success")
                     this.$router.push('/home')
                  })                  
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })
        },

        sendOfferLetterToRequester() {
             let payload = {
                requestId: this.request.id,
                nextLifecycle: '35'
            }
        
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/manager/return/requester`, payload)
              .then(response => {
                this.showRootToast("HRM Request Has Been Sent to Reqester", "Success", "success")
                this.$router.push('/home')
              })
        },

        repost() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '07'
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    this.$router.push('/home') 
                }) 
        },
        
        findOfferStatus() {        
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/lifecycle/${this.request.id}/35`)
              .then(response => {
                  if (response.data.message === "0") {
                      this.offerMade = false
                  } else {
                      this.offerMade = true
                  }
              })
        },

      hasReqAttachments() {
        if (this.attachmentReqs.length>0) {
          req:
              for (let i=0; i<this.attachmentReqs.length; i++) {
                for (let j=0; j<this.request.attachments.length; j++) {
                  if (this.attachmentReqs[i].attachmentTypeValue.code == this.request.attachments[j].type) {
                    break req;
                  }
                }
                return false;
              }
          return true;
        }
        return true;
      },

      findReqAttachments() {
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/attachment/requirements`, {typeCode: this.request.requestTypeValue.code, statusCode: this.request.requestStatusValue.code})
              .then(response => {
                this.attachmentReqs = response.data.filter((req) => req.required == true);
              })
      },

      maxLengthAlert(event) {
          let newValue = event.target.value;
          if (newValue.length >= this.projectMaxLength) {
            event.preventDefault()
            this.address = this.previousAddress;
            this.displayWarning = true;
          }
          else {
            this.address = newValue;
            this.previousAddress = newValue;
            this.displayWarning = false;
          }
        }
    }   
}
</script>
